import React, { Component } from "react";
import {
  Paper,
  Subheader,
  Divider,
  FlatButton,
  Card,
  CardHeader,
  CardText,
} from "material-ui";
import Formsy from "formsy-react";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Dropzone from "react-dropzone";
import ScanSnapOCR from "../../data/images/ScanSnapOCR.png";
import ScanSnapIcon from "../../data/images/ScanSnapIcon.png";

class UploadUnsigned8879s extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "Click to upload file, or drag and drop file",
      file: "",
      response: "",
      isLoading: false,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "150px",
          border: "3px dashed red",
        },
        activeZone: {
          width: "100%",
          height: "150px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
    };

    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  submitForm(data) {
    if (this.state.file) {
      this.setState({ message: "Uploading File", isLoading: true });
      let formData = new FormData();
      let url = "/api/documentUpload/uploadUnsigned";
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          this.checkStatus(json.ref);
        });
    }
  }

  checkStatus(ref) {
    console.log("checkStatus", ref);
    let url = `/api/documentUpload/docUploadReport?ref=${ref}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.status === "success") {
          this.setState({
            response: json.response,
            isLoading: false,
            message: "",
          });
        } else if (json.status === "failed") {
          this.setState({
            message: `Upload Failed, please contact the administrator with the reference number: ${ref}`,
          });
        } else {
          this.setState({ message: json.status });
          setTimeout(() => this.checkStatus(ref), 15000);
        }
      });
  }

  notifyFormError(data) {
    alert("Form error:", JSON.stringify(data, null, 4));
  }

  resetForm() {
    this.setState({
      file: "",
      response: "",
      isLoading: false,
      message: "Click to upload file, or drag and drop file",
    });
  }

  onDrop(e) {
    if (e[0].type === "application/pdf") {
      this.setState({ file: e[0] });
    } else {
      this.setState({ message: "Incorrect File Type, expecting PDF" });
    }
  }

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
            <h3>{this.state.message}</h3>
          </center>
        </div>
      );
    } else if (!response) {
      return (
        <div style={centerStyle}>
          <Dropzone
            onDrop={this.onDrop}
            disablePreview={true}
            style={zone}
            activeStyle={activeZone}
          >
            <center>
              <h4>
                {this.state.file ? this.state.file.name : this.state.message}
              </h4>
            </center>
          </Dropzone>
        </div>
      );
    } else {
      return (
        <div style={centerStyle}>
          <h4>Upload Results</h4>
          <BootstrapTable data={response}>
            <TableHeaderColumn
              dataField="clientId"
              filter={filter}
              dataSort
              isKey
              width="55"
            >
              Client ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              width="270"
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="year"
              dataSort
              filter={filter}
              width="50"
            >
              Year
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="message"
              dataSort
              filter={filter}
              width="100"
              dataFormat={this.sentFormatter}
            >
              Status
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="pages"
              dataSort
              filter={filter}
              width="35"
            >
              Pgs
            </TableHeaderColumn>
          </BootstrapTable>
          <Card style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
            <CardHeader
              title="Troubleshooting"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true} style={{ margin: "0.5em" }}>
              <p>
                1. <strong>Only 8879s should be uploaded in this input!</strong>
              </p>
              <p>
                2. If the table says 'There is no data to display' it means the
                PDF that was uploaded did not contain text with ClientIds and
                tax year.
              </p>
              <p>
                To ensure your scanned documents contain text, open the ScanSnap
                Settings by right-clicking{" "}
                <img
                  src={ScanSnapIcon}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  alt="the icon"
                />{" "}
                in the notification tray and selecting '
                <strong>Scan Button Settings...</strong>', Then configure OCR as
                shown in the image below.
              </p>
              <div>
                <center>
                  <img
                    src={ScanSnapOCR}
                    style={{ maxWidth: "75%", maxHeight: "75%" }}
                    alt="File option -> Select OCR -> ConverToSearchablePDF, OCR Options -> All Pages"
                  />
                </center>
              </div>
            </CardText>
          </Card>
        </div>
      );
    }
  }

  sentFormatter(status) {
    let color;
    if (status === "Ignored Duplicate File") {
      color = "orange";
    } else if (status !== "Success") {
      color = "red";
    }

    return <div style={{ color: color }}>{status}</div>;
  }

  render() {
    let { centerStyle, zone, activeZone } = this.state.styles;
    return (
      <Paper
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
      >
        <div style={centerStyle}>
          <h1 style={{ marginBottom: "1em" }}>Unsigned 8879 Upload Input</h1>
        </div>
        <Divider />
        <br />
        <div>{this.renderContent()}</div>
        <Divider />
        <Formsy.Form
          ref="form"
          onValidSubmit={this.submitForm}
          onInvalidSubmit={this.notifyFormError}
        >
          <div style={centerStyle}>
            <br />
            <FlatButton
              disabled={this.state.isLoading || !!this.state.response}
              type="submit"
              label="Submit"
            />
            <FlatButton
              disabled={this.state.isLoading}
              label="reset"
              onClick={this.resetForm.bind(this)}
            />
          </div>
        </Formsy.Form>
      </Paper>
    );
  }
}

export default UploadUnsigned8879s;



// WEBPACK FOOTER //
// ./app/components/documentUploader/UploadUnsigned8879s.js